import axiosIns from '@axios'

const $http = axiosIns

export const $getDefaultProjectWorkflow = async (params: object) => {
  return await $http.get('get-default-project-workflow/', { params })
}

export const $getCampaignWorkflowStatuses = async (campaignId: number) => {
  return await $http.get(`get-campaign-workflow-statuses/${campaignId}/`)
}
